export const filterHistoricalAssetsByDateRange = (
    flatData,
    fromYear,
    toYear,
    frequency = "monthly"
) => {
    if (!Array.isArray(flatData) || typeof fromYear !== "number" || typeof toYear !== "number") {
        console.warn("filterHistoricalAssetsByDateRange: invalid input");
        return flatData || [];
    }

    const dataKey = frequency === "annual" ? "annual_ret" : "returns";

    return flatData.filter((asset) => {
        // Keep every non-historical asset
        if (asset.type !== "historical") {
            return true;
        }

        const dataArray = asset[dataKey] || [];
        if (dataArray.length === 0) {
            console.warn(
                `Historical asset "${asset.assetName || asset.key || "unknown"}" has no ${dataKey} data → filtered out`
            );
            return false;
        }

        // Extract years
        const years = dataArray
            .map((item) => {
                if (!Array.isArray(item) || item.length < 1) return null;
                const dateCode = item[0];

                if (frequency === "annual") {
                    // annual_ret: first element is already the year (e.g. 2008)
                    return typeof dateCode === "number" ? dateCode : null;
                } else {
                    // monthly returns: format is yyyymm (e.g. 200801)
                    return typeof dateCode === "number" ? Math.floor(dateCode / 100) : null;
                }
            })
            .filter((year) => year !== null && year > 0);

        if (years.length === 0) return false;

        const startYear = Math.min(...years);
        const endYear = Math.max(...years);

        const fullyCoversRange = startYear <= fromYear && endYear >= toYear;

        if (!fullyCoversRange) {
            console.warn(
                `Historical asset "${asset.assetName || asset.key || "unknown"}" filtered out ` +
                `(data: ${startYear}-${endYear}, required: ${fromYear}-${toYear}, frequency: ${frequency})`
            );
        }

        return fullyCoversRange;
    });
};